import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuoteRequestService } from '@app/shared/services/quote-request.service';

@Component({
  selector: 'app-text-area-dialog',
  templateUrl: './text-area-dialog.component.html',
  styleUrls: ['./text-area-dialog.component.scss']
})
export class TextAreaDialogComponent implements OnInit {
    public frmTextArea: FormGroup;
    public maxCharacters = 255;
    constructor(
      public dialogRef: MatDialogRef<TextAreaDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private fb: FormBuilder
    ) {
      if (data.maxCharacters) {
        this.maxCharacters = data.maxCharacters;
      }
    }

    ngOnInit() {
      this.frmTextArea = this.fb.group({
        textAreaControl: new FormControl('', [Validators.required, Validators.maxLength(this.maxCharacters)]),
      });
    }

    public send() {
      this.frmTextArea.updateValueAndValidity();
      this.frmTextArea.markAllAsTouched();

      if (this.frmTextArea.valid) {
        this.dialogRef.close({
          success: true,
          textAreaInput: this.frmTextArea.get('textAreaControl').value,
        });
      }
    }
  }
